import type { HidePricesConfig } from './types/config'

const getByPath = (
  source: Record<string, unknown> | undefined | null,
  path: string,
): unknown => {
  if (typeof path !== 'string') {
    return undefined
  }
  return path
    .split('.')
    .reduce<unknown>(
      (acc, key) =>
        acc && typeof acc === 'object'
          ? (acc as Record<string, unknown>)[key]
          : undefined,
      source ?? undefined,
    )
}

export const isHidePricesMisconfigured = (
  hidePricesConfig: HidePricesConfig | undefined,
): boolean => {
  if (!hidePricesConfig?.enabled) {
    return false
  }
  return (
    typeof hidePricesConfig.customField !== 'string' ||
    !hidePricesConfig.customField ||
    hidePricesConfig.flagValue == null ||
    hidePricesConfig.flagValue === ''
  )
}

export const resolveHidePrices = (
  hidePricesConfig: HidePricesConfig | undefined,
  customFields: Record<string, unknown> | undefined | null,
): boolean => {
  if (!hidePricesConfig?.enabled) {
    return false
  }
  if (isHidePricesMisconfigured(hidePricesConfig)) {
    return false
  }
  const { customField = '', flagValue } = hidePricesConfig
  const value = getByPath(customFields, customField)
  return String(value) === String(flagValue)
}
